import React, { createContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Apis } from "../utils/apis";
import { FaSpinner } from "react-icons/fa";
import { useWauth } from "../auth/WauthProvider";
import useLocalStorage from "../hooks/useLocalStorage";
import useLocalStoragePrimitive from "../hooks/useLocalStoragePrimitive";

export const SiteContext = createContext({
  salaId: null,
  setSalaId: () => {},
  sala: {},
  setSala: () => {},
  userInfo: {},
});

export const SiteProvider = ({ children }) => {
  const { isAuthenticated } = useWauth();

  const [sala, setSala] = useLocalStorage("sala", {});
  const [userInfo, setUserInfo] = useLocalStorage("userInfo", {});
  const [salaId, setSalaId] = useLocalStoragePrimitive("salaId", 0);
  
  const fetchUser = async () => {
    const response = await axios.get(`${Apis.USER}/users/me`, {
      params: { product: "gaming" },
    });
    return response.data;
  };

   const { data, isPending } = useQuery({
     queryKey: ["getUser"],
     queryFn: fetchUser,
   });

  useMemo(() => {
    if (data?.user !== undefined && data?.user !== null) {
      setUserInfo(data)
    }
    // eslint-disable-next-line
  }, [data])

  if (isPending && isAuthenticated) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-screen gap-4 select-none text-neutral-950 animate-pulse">
        <FaSpinner className="animate-spin" size={24} />
        <span>Cargando...</span>
      </div>
    );
  }

  return (
    <SiteContext.Provider
      value={{
        salaId,
        setSalaId,
        sala,
        setSala,
        userInfo,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
};
